export default __webpack_public_path__ + "static/media/sec3.823d458a.png";